/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

//Navigate to home page when not on the home page
const handleCoverageCheck = function(item: FuseNavigationItem) 
{    
    
};


// background colors are edited directly on the html component
export const defaultNavigation: FuseNavigationItem[] =
[
    {
        id   : 'home',
        title: 'Home',
        type : 'basic',
        externalLink: false,
        link: '/home',
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-lg"
        },
    },
    {
        id   : 'deals',
        title: 'Deals',
        type : 'basic',
        externalLink: false,
        link:'products/fibre',
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-lg"
        },       
    },
    {
        id   : 'support',
        title: 'Support',
        type : 'basic',
        externalLink: false,
        link: 'support',
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-lg"
        },
    },
    {
        id   : 'contact',
        title: 'Contact Us',
        type : 'basic',
        externalLink: false,
        link: 'contact-us',
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-lg"
        },
    }    
];

export const defaultLoggedInNavigation: FuseNavigationItem[] =
[
    {
        id   : 'home',
        title: 'HOME',
        type : 'collapsable',
        externalLink: false,
        link: '/home',
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-lg font-bold"
        },
        children: [
            {
                id   : 'check_coverage',
                title: 'Check Coverage',
                type : 'basic',
                externalLink: false,
                link: '/home',
                classes:
                {
                    wrapper: "ml-10",
                    title: "text-lg"
                },
            },
            {
                id   : 'deals',
                title: 'Deals',
                type : 'basic',
                externalLink: false,
                link: 'products/fibre',
                classes:
                {
                    wrapper: "ml-10",
                    title: "text-lg"
                },
            },
            {
                id   : 'support',
                title: 'Support',
                type : 'basic',
                externalLink: false,
                link: 'support',
                classes:
                {
                    wrapper: "ml-10",
                    title: "text-lg"
                },
            },
            {
                id   : 'contact_us',
                title: 'Contact us',
                type : 'basic',
                externalLink: false,
                link: 'contact-us',
                classes:
                {
                    wrapper: "ml-10",
                    title: "text-lg"
                },
            },
        ],
    },
    {
        id   : 'dashboard',
        title: 'DASHBOARD',
        type : 'collapsable',
        externalLink: false,
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-lg font-bold"
        },
        children: [
            {
                id   : 'profile',
                title: 'My profile',
                type : 'basic',
                externalLink: false,
                link: 'dashboard/profile',
                exactMatch: true,
                classes:
                {
                    wrapper: "ml-10 text-start",
                    title: "text-lg text-start w-full"
                },
            },
            {
                id   : 'request',
                title: 'My requests',
                type : 'basic',
                externalLink: false,
                link: '/dashboard/requests',
                exactMatch: true,
                classes:
                {
                    wrapper: "ml-10",
                    title: "text-lg text-start"
                },
            },
            {
                id   : 'services',
                title: 'My services',
                type : 'basic',
                externalLink: false,
                link: '/dashboard',
                fragment: 'services',
                exactMatch: true,
                classes:
                {
                    wrapper: "ml-10",
                    title: "text-lg text-start"
                },
            },
            {
                id   : 'billing_and_statements',
                title: 'Billing and Statements',
                type : 'basic',
                externalLink: false,
                link: `/dashboard/invoices`,
                exactMatch: true,
                classes:
                {
                    wrapper: "ml-10",
                    title: "text-lg text-start"
                },
            },
        ]
    }        
];



export const horizontalNavigationLoggedIn: FuseNavigationItem[] =
[
    {
        id   : 'home',
        title: 'Home',
        type : 'basic',
        externalLink: false,
        link: 'home',
        classes:
        {
            wrapper:'rounded-full background-button-white hover:bg-secondary-100 active:bg-secondary hover:font-extrabold active:text-primary px-[32px] hover:px-[32px]',
            title:"  text-lg"
        },
    },
    {
        id   : 'products',
        title: 'Deals',
        type : 'basic',
        externalLink: false,
        link:'/products/fibre',
        classes:
        {
            wrapper:'rounded-full background-button-white hover:bg-secondary-100 active:bg-secondary hover:font-extrabold active:text-primary px-[32px] hover:px-[32px]',
            title:"  text-lg"
        }        
    },
    {
        id   : '',
        title: 'Support',
        type : 'basic',
        externalLink: false,
        link: 'support',
        // icon:'arrow_drop_down',
        classes:
        {
            wrapper:'rounded-full background-button-white hover:bg-secondary-100 active:bg-secondary hover:font-extrabold active:text-primary px-[32px] hover:px-[32px]',
            title:"  text-lg"
        },
    },
    {
        id   : 'contact',
        title: 'Contact Us',
        type : 'basic',
        externalLink: false,
        link: 'contact-us',
        classes:
        {
            wrapper:'rounded-full background-button-white hover:bg-secondary-100 active:bg-secondary hover:font-extrabold active:text-primary px-[32px] hover:px-[32px]',
            title:"text-lg"
        },
    },
    {
        id   : 'checkCoverage',
        title: 'Check coverage',
        type : 'basic',
        externalLink: false,
        link: 'home',
        classes:
        {
            icon: "font-extrabold",
            wrapper:'rounded-full bg-primary hover:bg-secondary-100 active:bg-secondary hover:font-extrabold active:text-primary text-secondary-200 font-bold px-[32px] hover:px-[32px]',
            title:"text-lg font-extrabold active:text-primary text-secondary"
        }
        ,function:handleCoverageCheck
    },

    // {
    //     id   : 'blog',
    //     title: 'Blog',
    //     type : 'basic',
    //     externalLink: false,
    //     link: 'blogs',
    //     classes:
    //     {
    //         wrapper:'rounded-full',
    //         title:"  text-lg"
    //     },
    // },

];


export const defaultNavigationLoggedIn: FuseNavigationItem[] = [
        // {
        //     id   : 'home',
        //     title: 'HOME',
        //     type : 'collapsable',
        //     externalLink: false,
        //     classes:
        //     {
        //         wrapper: "my-2 mx-0 rounded bg-primary",
        //         title: "text-white text-md",
        //         icon: "text-white"
        //     }
        //     ,children:
        //     [
        //         { title: 'Check Coverage', type : 'basic', link:'/',  classes:{
        //             title: "text-white font-extrabold",   
        //         }},
        //         {
        //             id   : 'products',
        //             title: 'Deals',
        //             type : 'basic',
        //             externalLink: false,
        //             link:'/products/fibre',
        //             classes:
        //             {
        //                 wrapper:'rounded-full background-button-white',
        //                 title:"  text-lg"
        //             }        
        //         },
        //         //{ title: 'Deals', type : 'basic', link:'/deals',  classes:{
        //         //    title: "text-white font-bold",   
        //         //}},
        //         //{ title: 'About Us', type : 'basic', link:'/about-us',  classes:{
        //         //    title: "text-white font-bold",   
        //         //}},
        //         { title: 'Support', type : 'basic', link:'/support',  classes:{
        //             title: "text-white font-bold",   
        //         }},
        //         { title: 'Contact Us', type : 'basic', link:'/contact-us',  classes:{
        //             title: "text-white font-bold",   
        //         }},
              
        //     ]
        // },
        // {
        //     id   : 'dashboard',
        //     title: 'DASHBOARD',
        //     type : 'collapsable',
        //     externalLink: false,
        //     classes:
        //     {
        //         wrapper: "my-2 mx-0 rounded bg-primary",
        //         title: "text-white text-md",
        //         icon: "text-white"
        //     }
        //     ,children:
        //     [
        //         { title: 'My Profile', type : 'basic', link:'/dashboard/profile',  classes:{
        //             title: "text-white font-bold",   
        //         }},
               
        //         { title: 'My Requests', type : 'basic', link:'/dashboard/requests',  classes:{
        //             title: "text-white font-bold",   
        //         }},

        //         { title: 'My Services', type : 'basic', link:'/dashboard',  classes:{
        //             title: "text-white font-bold",   
        //         }},

        //         // { title: 'Payment Methods', type : 'basic', link:'/dashboard/profile',  classes:{
        //         //     title: "text-white font-bold",   
        //         // }},

        //         { title: 'Billing and Statements', type : 'basic', link:'/dashboard/invoices',  classes:{
        //             title: "text-white font-bold",   
        //         }},
              
        //     ]
        // },
];

// Mobile navigation for non-logged-in users (simplified)
export const mobileGuestNavigation: FuseNavigationItem[] = [
    {
        id   : 'check_coverage',
        title: 'Check Coverage',
        type : 'basic',
        externalLink: false,
        link: '/home',
        icon: 'heroicons_outline:map-pin',
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-base font-medium px-2"
        },
    }
];

// Mobile navigation for logged-in users (profile menu items)
export const mobileLoggedInNavigation: FuseNavigationItem[] = [
    {
        id   : 'dashboard_overview',
        title: 'Dashboard',
        type : 'basic',
        externalLink: false,
        link: '/dashboard',
        icon: 'heroicons_outline:squares-2x2',
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-base font-medium px-2"
        },
    },
    {
        id   : 'my_profile',
        title: 'My Profile',
        type : 'basic',
        externalLink: false,
        link: '/dashboard/profile',
        icon: 'heroicons_outline:user-circle',
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-base px-2"
        },
    },
    {
        id   : 'support_tickets',
        title: 'Tickets',
        type : 'basic',
        externalLink: false,
        link: '/dashboard/requests',
        icon: 'heroicons_outline:chat-bubble-left-ellipsis',
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-base px-2"
        },
    },
    {
        id   : 'billing_statements',
        title: 'Billing & Statements',
        type : 'basic',
        externalLink: false,
        link: '/dashboard/invoices',
        icon: 'heroicons_outline:document-text',
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-base px-2"
        },
    },
    {
        id   : 'pay_now',
        title: 'Pay Now',
        type : 'basic',
        externalLink: false,
        link: '/balances',
        icon: 'heroicons_outline:credit-card',
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-base px-2"
        },
    },
    {
        id   : 'network_status',
        title: 'Network Status',
        type : 'basic',
        externalLink: true,
        target: '_blank',
        link: 'https://speed.Infinifi.co.za/',
        icon: 'heroicons_outline:wifi',
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-base px-2"
        },
    },
    {
        id   : 'help_center',
        title: 'Help Center',
        type : 'basic',
        externalLink: true,
        target: '_blank',
        link: 'https://www.Infinifi.co.za/contact-us',
        icon: 'heroicons_outline:question-mark-circle',
        classes:
        {
            wrapper: "mx-0 py-2",
            title: "text-base px-2"
        },
    }
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
